// @ts-check
import * as z from 'zod';

import { IS_DEV_STAGE, IS_PROD_STAGE, SDK_TOKEN } from '@/js/constants';

// NOTE: 上傳圖片指令
// REF: https://17media.slack.com/archives/G01AB5XUVNW/p1703484022048549?thread_ts=1703483852.816689&cid=G01AB5XUVNW

export const isCosme = () => {
  return (IS_PROD_STAGE && SDK_TOKEN === 'xjpllx29') ||
    (IS_DEV_STAGE && SDK_TOKEN === 'e2ndnl67');
};

// jira: https://17media.atlassian.net/browse/HU-7705
const SPECIAL_TITLE_LUT_20241025 = Object.freeze({
  '241025①': {
    mobile: {
      gcsPath: 'HU-6640/48_ph1_bd2024_liveshopping_lp_profile_sp_750_1805.png',
      url: 'https://lh3.googleusercontent.com/tmgHJfGvWSQCj-BcuiaDri0GHgUFINhbr7J4amt5aErZKBIn130lP-DipZNdGXpn9kE-caZ-jTJAT9AcE59HFzKnJVyBSu_1z_KMpg=s0',
    },
    others: {
      gcsPath: 'HU-6640/49_ph5_1_bd2024_liveshopping_lp_profile_pc_1200_1033.png',
      url: 'https://lh3.googleusercontent.com/td9QHz3TGwHmy_QmsKxrfzmJVkdgvwIZo9lm6esEnfm4D6W3GvPN0JyKLJHUWzs8vMUJh3ta4atebC3ec4SzZF1fy5Z_jo0T-Tth=s0',
    },
  },
  '241025②': {
    mobile: {
      gcsPath: 'HU-6640/44_ph1_bd2024_liveshopping_lp_schedule_sp_750_778.png',
      url: 'https://lh3.googleusercontent.com/b9M6nXa0Yx6t3L2qD-lBDU7sN5OyawQjUC2R0hmDGAmzRAPO2gBjkMubhIdTcZhO9zMl0YmWj8O6Hb4YF7tD79MQ6qYj5rKEKiMZJg=s0',
    },
    others: {
      gcsPath: 'HU-6640/45_ph1_bd2024_liveshopping_lp_schedule_pc_1200_600.png',
      url: 'https://lh3.googleusercontent.com/Da7NKirOH-jTpaN1PeILZQUFNSvjZIsAEiJv_vWhsDiaXCXL_OunniiBf7IOAqfqFdqfy3wNfqsXwY8IGxdgzalaaOsYLjE5bISvcA=s0',
    },
  },
});

// jira: https://17media.atlassian.net/browse/HU-7896
const SPECIAL_TITLE_LUT_20241125 = Object.freeze({
  '241201_list': {
    mobile: {
      gcsPath: 'HU-6350/47_liveshopping_BD2023_lp_bottom_750_715.png',
      url: 'https://lh3.googleusercontent.com/8nlezR5QKmIImtdiSMfpnA4qwdVaPvDWqY0eaUF1LptUARq8nI3kM3tSa0b1x8PWlMzdGsh8KX-eIcW3t8kEbzUqSNnKWzXlHxYNog=s0',
    },
    others: {
      gcsPath: 'HU-6350/46_liveshopping_BD2023_lp_bottom_1200_600.png',
      url: 'https://lh3.googleusercontent.com/zrt7P7ScoSOehk8nKSDdYad5k8KPlgS4hNUCSlb2V-y1xA0Ecb9IAlrhlm-4E1nyqsd4LqEcrdgh_wv1vGHeAdwXpBN0KCaxpobV=s0',
    },
  },
  '241202_list': {
    mobile: {
      gcsPath: 'HU-6350/47_liveshopping_BD2023_lp_bottom_750_715.png',
      url: 'https://lh3.googleusercontent.com/HkMJ_ALMyzFyWxQuwLg3HAjaiP9CCusfj1gfe1VunoCOCSiqgiUflLZB8wL3pEZOBpimpZF50TS4iU0jAxbR2k6PhqSYj_zv0ckZBQ=s0',
    },
    others: {
      gcsPath: 'HU-6350/46_liveshopping_BD2023_lp_bottom_1200_600.png',
      url: 'https://lh3.googleusercontent.com/-k1uxVrB1oXugWRx283QrvTS5U0Aa791OVfX9jM8qL0zpAVeyDBd-JeNnzsxGEBOMQV_F-x1ZoEDImbMiVxt3BySR9hewKjCKsc1=s0',
    },
  },
  '241203_list': {
    mobile: {
      gcsPath: 'HU-6350/47_liveshopping_BD2023_lp_bottom_750_715.png',
      url: 'https://lh3.googleusercontent.com/B-cAJJKpzmZ77kDSHJmJeOdiCW_8wbcjlUXb07hfOQ2sQrHpJIZqUbgynK6H1wWDiFQCX5iuCvgYWLqKbEDhxoiJ0FAtg0OeTsKkU2o=s0',
    },
    others: {
      gcsPath: 'HU-6350/46_liveshopping_BD2023_lp_bottom_1200_600.png',
      url: 'https://lh3.googleusercontent.com/725arQ4_8_5V53cHXh9ps6nYVMd53DZOLvKf3_pNz3gCc-fDeLtABGHGsvL6OUlFZEYsZCdQ9H_S1ctGC0kBR89DbyNvd-c9zvdOOQ=s0',
    },
  },
});

const SPECIAL_TITLE_LUT = Object.assign({}, SPECIAL_TITLE_LUT_20241025, SPECIAL_TITLE_LUT_20241125);

/**
 * @param parentEl
 * @param selectors
 */
const waitUntilChildrenRendered = async (parentEl: HTMLElement, selectors: string[] = []) => {
  const fn = () => Array.from(selectors).every((s) => parentEl.querySelector(s));

  return new Promise((resolve) => {
    if (fn()) { return resolve(true); }

    const observer = new MutationObserver(() => {
      if (fn()) {
        observer.disconnect();
        resolve(true);
      }
    });
    observer.observe(parentEl, { subtree: true, childList: true });
  });
};

/** @param title */
const parseSpecialTitle = (title: string) => {
  try {
    return z.object({
      title: z.string(),
      img: z.enum(['241025①', '241025②', '241201_list', '241202_list', '241203_list']),
    }).parse(JSON.parse(title));
  } catch (e) {
    return null;
  }
};

/** @param bannerModuleEl */
const responsifyBannerImage = (bannerModuleEl: HTMLElement) => {
  const bannerWrapperEl = bannerModuleEl.querySelector('.module-banner-display__wrapper') as HTMLElement | null;
  if (!bannerWrapperEl) { return; }

  const bannerImageWrapperEl = bannerWrapperEl.querySelector('.module-banner-display__wrapper__image') as HTMLElement | null;
  if (!bannerImageWrapperEl) { return; }

  const imgEl = bannerWrapperEl.querySelector('.el-image img') as HTMLImageElement | null;
  if (!imgEl) { return; }

  const bannerTitleEl = bannerModuleEl.querySelector('.module-banner-display__title') as HTMLElement | null;
  if (!bannerTitleEl) { return; }

  const parsedBannerTitleResult = parseSpecialTitle(String(bannerTitleEl.textContent));
  if (!parsedBannerTitleResult) { return; }

  bannerTitleEl.textContent = parsedBannerTitleResult.title;
  if (!parsedBannerTitleResult.title) {
    bannerTitleEl.hidden = true;
  }

  const imageFromSpecialTitle = SPECIAL_TITLE_LUT[parsedBannerTitleResult.img];
  const [mImgWidth, mImgHeight] = imageFromSpecialTitle.mobile.gcsPath
    .match(/^.*\D(\d+)_(\d+)[.].*$/)?.slice(1) ?? [0, 0];

  bannerWrapperEl.style.setProperty('--tw-bg-opacity', '0');

  Object.assign(bannerWrapperEl.style, {
    padding: 0,
    height: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
  });

  Object.assign(bannerImageWrapperEl.style, {
    position: 'relative',
  });

  const changeImageSrc = () => {
    const isMobileLayout = bannerWrapperEl.closest('main.main-layout.mobile');

    if (imgEl.src !== imageFromSpecialTitle.mobile.url && isMobileLayout) {
      imgEl.src = imageFromSpecialTitle.mobile.url;
      Object.assign(bannerWrapperEl.style, {
        maxWidth: `${mImgWidth}px`,
        maxHeight: `${mImgHeight}px`,
      });
    }

    if (imgEl.src !== imageFromSpecialTitle.others.url && !isMobileLayout) {
      imgEl.src = imageFromSpecialTitle.others.url;
      Object.assign(bannerWrapperEl.style, {
        maxWidth: '',
        maxHeight: '',
      });
    }
  };
  changeImageSrc();
  window.addEventListener('resize', changeImageSrc);
};

export const customizeResponsiveBannerImageBySpecificTitle = () => {
  const bannerModuleEls = Array.from(document.querySelectorAll('.module-banner-display.module-container')) as HTMLElement[];
  bannerModuleEls.forEach(async (bannerModuleEl) => {
    await waitUntilChildrenRendered(
      bannerModuleEl,
      ['.el-image img', '.module-banner-display__title'] as string[],
    );
    responsifyBannerImage(bannerModuleEl);
  });
};
